import Hero from "@/components/sections/Hero";
import TrustStrip from "@/components/sections/TrustStrip";
import TwoProblems from "@/components/sections/TwoProblems";
import Features from "@/components/sections/Features";
import Solution from "@/components/sections/Solution";
import OverlayVisual from "@/components/sections/OverlayVisual";
import UseCases from "@/components/sections/UseCases";
import HowItWorks from "@/components/sections/HowItWorks";
import LiveExamples from "@/components/sections/LiveExamples";
import BlackBox from "@/components/sections/BlackBox";
import Roadmap from "@/components/sections/Roadmap";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TrustStrip />
      <TwoProblems />
      <Features />
      <Solution />
      <OverlayVisual />
      <UseCases />
      <HowItWorks />
      <LiveExamples />
      <BlackBox />
      <Roadmap />
    </div>
  );
}
